import { apiClient } from './client';

/**
 * Tier 2 temps-réel — demande au serveur de résoudre tout de suite les tâches
 * dues du joueur (build/recherche/production), au lieu d'attendre le tick 10s.
 * Idempotent côté serveur. Retourne le nombre de tâches résolues.
 */
export async function resolveMine(playerUniverseId: number): Promise<number> {
  const { data } = await apiClient.post<{ resolved: number }>(
    '/api/v1/Tick/resolve-mine', null, { params: { playerUniverseId } },
  );
  return data?.resolved ?? 0;
}
